import { Component, OnInit, AfterContentInit } from '@angular/core';
import { Router } from "@angular/router";
import { ClientService } from "../../services/client.service";
import { AuthService } from "../../services/auth.service";
import { ConfigService } from "../../utils/config.service";
declare var $: any;

@Component({
  selector: 'sa-header',
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, AfterContentInit {
  client: any = {};
  mainLogoStyle: any = {};
  mainHeaderStyle: any = {};
  isTest: boolean = true;
  constructor(private router: Router, private clientService: ClientService, private config: ConfigService, private authService: AuthService) {
    this.client = this.clientService.getClient();

    //this.mainHeaderStyle = { 'background-color': 'lime' };

    this.clientService.getUpdatedClient().subscribe(data => {
      this.client = data;
      try {
        if (this.client != null && this.client.clientSetting.siteSetting.mainHeaderStyle != null)
          this.mainHeaderStyle = JSON.parse(this.client.clientSetting.siteSetting.mainHeaderStyle || {});


      }
      catch (e) {

      }

      try {
        if (this.client != null && this.client.clientSetting != null) {

          this.mainLogoStyle = JSON.parse(this.client.clientSetting!.siteSetting!.mainLogoStyle || {});
        }
      }
      catch (e) {

      }

    });
  }

  ngOnInit() {
    this.mainHeaderStyle = this.client.clientSetting.siteSetting.mainHeaderStyle != null ? JSON.parse(this.client.clientSetting.siteSetting.mainHeaderStyle) : {};
    if (this.config.environmentName == "prod") {
      this.isTest = false;
    }
  }

  // Angular Life Cycle Used.
  ngAfterContentInit() {
    this.ngOnInit();
  }

  searchMobileActive = false;

  toggleSearchMobile() {
    this.searchMobileActive = !this.searchMobileActive;

    $('body').toggleClass('search-mobile', this.searchMobileActive);
  }

  onSubmit() {
    this.router.navigate(['/miscellaneous/search']);

  }


}
